import React from 'react';

/**
 * lot DK2 — filtre sur téléphone : un libellé lisible en 14 px et, par-dessus, le `<select>` natif
 * transparent en 16 px (l'iPhone ne zoome pas et ouvre son sélecteur natif).
 */
export const SelecteurTelephone = ({
  value, onChange, options, ariaLabel, testId, className = '',
}) => {
  const choisie = options.find((o) => String(o.valeur) === String(value));
  return (
    <div className={`relative h-11 min-w-0 ${className}`}>
      <div className="h-11 w-full px-3 pr-8 flex items-center rounded-[10px] bg-white border border-[#CBD5E1]">
        <span className="truncate text-[14px] font-medium text-[#0F172A]">
          {choisie ? choisie.libelle : ''}
        </span>
        <i className="bi bi-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs"></i>
      </div>
      <select
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
        data-testid={testId}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        style={{ fontSize: '16px' }}
      >
        {options.map((o) => (
          <option key={o.valeur} value={o.valeur}>{o.libelle}</option>
        ))}
      </select>
    </div>
  );
};

export default SelecteurTelephone;
